module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar'), _vm._v(" "), _c('div', {
    staticClass: "sidebar bg-darkgrey navbar-inverse side-box-shadow"
  }, [_c('ul', {
    staticClass: "nav flex-column"
  }, [_c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "current"
    }
  }, [_c('a', {
    staticClass: "nav-link navbar-text pull-left",
    attrs: {
      "href": "#/OrderPending"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.sidebar.pending')))]), _vm._v(" "), (_vm.orders.length > 0) ? _c('span', {
    staticClass: "pull-right badge badge-default"
  }, [_vm._v(_vm._s(_vm.orders.length))]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-text pull-left",
    attrs: {
      "href": "#/OrderCurrent"
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.sidebar.current')))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-kne-orange col-12 mt-3",
    attrs: {
      "id": "addOrder"
    },
    on: {
      "click": function($event) {
        _vm.addOrderAction()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t('OrderPending.sidebar.add_order')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "view"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "my-2"
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover font-grey mb-0 table-sm"
  }, [_c('thead', {
    staticClass: "bg-darkgrey"
  }, [_c('tr', [_c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('numRef', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.ref'))), (_vm.sort.current === 'numRef') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('vin', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.VIN'))), (_vm.sort.current === 'vin') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('source', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.source'))), (_vm.sort.current === 'source') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('creationDate', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.date'))), (_vm.sort.current === 'creationDate') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('transmitterName', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.pickup'))), (_vm.sort.current === 'transmitterName') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('receiverName', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.delivery'))), (_vm.sort.current === 'receiverName') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th', {
    staticClass: "sortable nowrap",
    on: {
      "click": function($event) {
        _vm.sortBy('payerName', false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderCurrent.billing'))), (_vm.sort.current === 'payerName') ? _c('i', {
    staticClass: "ml-1 fa",
    class: {
      'fa-arrow-down': _vm.sort.desc, 'fa-arrow-up': !_vm.sort.desc
    },
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, [_c('tr', {
    key: "filter"
  }, [_c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields['numRef'],
      "placeholder": _vm.$t('OrderPending.ref')
    },
    on: {
      "input": function($event) {
        _vm.fields['numRef'] = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.vin,
      "placeholder": _vm.$t('OrderPending.VIN')
    },
    on: {
      "input": function($event) {
        _vm.fields.vin = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.source,
      "placeholder": _vm.$t('OrderPending.source')
    },
    on: {
      "input": function($event) {
        _vm.fields.source = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.creationDate,
      "placeholder": _vm.$t('OrderCurrent.date')
    },
    on: {
      "input": function($event) {
        _vm.fields.creationDate = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.transmitterName,
      "placeholder": _vm.$t('OrderCurrent.pickup')
    },
    on: {
      "input": function($event) {
        _vm.fields.transmitterName = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.receiverName,
      "placeholder": _vm.$t('OrderCurrent.delivery')
    },
    on: {
      "input": function($event) {
        _vm.fields.receiverName = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.payerName,
      "placeholder": _vm.$t('OrderCurrent.billing')
    },
    on: {
      "input": function($event) {
        _vm.fields.payerName = $event;
        _vm.filteredSearchMethod()
      }
    }
  })], 1), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })]), _vm._v(" "), _vm._l((_vm.filterResults), function(order) {
    return _c('tr', {
      key: order['.key']
    }, [_c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(order.numRef))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(order.vin))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(order.source))])]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_vm._v(_vm._s(_vm.getDate(order.creationDate)))]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(order.transmitterName))])]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(order.receiverName))])]), _vm._v(" "), _c('td', {
      staticClass: "nowrap"
    }, [_c('p', {
      staticClass: "table-fix-width"
    }, [_vm._v(_vm._s(order.payerName))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right",
      attrs: {
        "id": "action"
      }
    }, [(_vm.isSageOne) ? _c('button', {
      staticClass: "btn btn-kne-orange",
      attrs: {
        "disabled": _vm.inProgress === order['.key']
      },
      on: {
        "click": function($event) {
          _vm.openPrice(order)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-kne-orange",
      attrs: {
        "disabled": _vm.inProgress === order['.key']
      },
      on: {
        "~click": function($event) {
          _vm.action(order, true)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "ml-2 btn btn-kne-orange",
      attrs: {
        "disabled": _vm.inProgress === order['.key']
      },
      on: {
        "~click": function($event) {
          _vm.action(order, false)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])
  })], 2)], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.closedModal !== true) ? _c('modal', {
    attrs: {
      "closable": ""
    },
    on: {
      "close-request": function($event) {
        _vm.closedModal = true;
        _vm.clear()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-6 pr-0",
    attrs: {
      "id": "Order"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.orderTab.order')))]), _vm._v(" "), _c('div', {}, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.source,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.orderTab.source')
    },
    on: {
      "input": function($event) {
        _vm.order.source = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {}, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.datePromis,
      "type": "date",
      "placeholder": _vm.$t('OrderPending.orderTab.datePromis')
    },
    on: {
      "input": function($event) {
        _vm.order.datePromis = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {}, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.numRef,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.orderTab.reference')
    },
    on: {
      "input": function($event) {
        _vm.order.numRef = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {}, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.price,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.orderTab.price')
    },
    on: {
      "input": function($event) {
        _vm.order.price = $event
      }
    }
  }), _vm._v(" "), _c('regular-textarea', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.comment,
      "rows": "4",
      "placeholder": _vm.$t('OrderPending.orderTab.comment')
    },
    on: {
      "input": function($event) {
        _vm.order.comment = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 pl-0",
    attrs: {
      "id": "vehicle"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.vehicleInfoTab.vehicle_info')))]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.VIN,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.vehicleInfoTab.VIN')
    },
    on: {
      "input": function($event) {
        _vm.VIN = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100 form-group",
    attrs: {
      "disabled": _vm.VIN === ''
    },
    on: {
      "click": function($event) {
        _vm.validate(_vm.VIN)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.vehicleInfoTab.validate')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.MAKE,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.vehicleInfoTab.make')
    },
    on: {
      "input": function($event) {
        _vm.MAKE = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.MODEL,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.vehicleInfoTab.model')
    },
    on: {
      "input": function($event) {
        _vm.MODEL = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.YEAR,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.vehicleInfoTab.year')
    },
    on: {
      "input": function($event) {
        _vm.YEAR = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100 form-group",
    on: {
      "click": function($event) {
        _vm.addVehicle()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.vehicleInfoTab.add_vehicle')))])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', {}, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderPending.vehicleInfoTab.VIN')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderPending.vehicleInfoTab.year')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderPending.vehicleInfoTab.make')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('OrderPending.vehicleInfoTab.model')))])])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, _vm._l((_vm.vehicles), function(vehicle, index) {
    return _c('tr', {
      key: vehicle.vin + vehicle.year
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicle.vin))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicle.year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicle.make))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(vehicle.model))])])
  }))], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "mt-3 col-4 pr-0",
    attrs: {
      "id": "pickup"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.pickupDeliveryTab.pickup')))]), _vm._v(" "), _c('regular-datalist', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.datalist.pickup,
      "originalList": _vm.$store.state.allContacts,
      "secondList": _vm.addressbook,
      "placeholder": _vm.$t('AddressBook.title')
    },
    on: {
      "input": function($event) {
        _vm.setAndSearch($event, 'pickup')
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterName,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.name') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterName = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterAddress,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.address') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterAddress = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterCity,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.city')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterCity = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterPostcode,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.postal_code')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterPostcode = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterProvince,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.province')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterProvince = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterCountry,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.country')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterCountry = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterEmail,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.email')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterEmail = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterPhone,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.phone')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterPhone = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterFax,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.fax')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterFax = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.transmitterContact,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.contact')
    },
    on: {
      "input": function($event) {
        _vm.order.transmitterContact = $event
      }
    }
  }), _vm._v(" "), _c('regular-checkbox', {
    staticClass: "col-12",
    attrs: {
      "checked": _vm.pickupSave,
      "label": _vm.$t('OrderPending.pickupDeliveryTab.save_dealer')
    },
    on: {
      "change": function($event) {
        _vm.pickupSave = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-4 px-0",
    attrs: {
      "id": "delivery"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.pickupDeliveryTab.delivery')))]), _vm._v(" "), _c('regular-datalist', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.datalist.delivery,
      "originalList": _vm.$store.state.allContacts,
      "secondList": _vm.addressbook,
      "placeholder": _vm.$t('AddressBook.title')
    },
    on: {
      "input": function($event) {
        _vm.setAndSearch($event, 'delivery')
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverName,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.name') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.receiverName = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverAddress,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.address') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.receiverAddress = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverCity,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.city')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverCity = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverPostcode,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.postal_code')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverPostcode = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverProvince,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.province')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverProvince = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverCountry,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.country')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverCountry = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverEmail,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.email')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverEmail = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverPhone,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.phone')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverPhone = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverFax,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.fax')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverFax = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.receiverContact,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.contact')
    },
    on: {
      "input": function($event) {
        _vm.order.receiverContact = $event;
        _vm.onInputBillingSame()
      }
    }
  }), _vm._v(" "), _c('regular-checkbox', {
    staticClass: "col-12",
    attrs: {
      "checked": _vm.deliverySave,
      "label": _vm.$t('OrderPending.pickupDeliveryTab.save_dealer')
    },
    on: {
      "change": function($event) {
        _vm.deliverySave = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-4 pl-0",
    attrs: {
      "id": "billing"
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.pickupDeliveryTab.billing')))]), _vm._v(" "), _c('regular-datalist', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.datalist.billing,
      "disabled": _vm.billingSame,
      "originalList": _vm.$store.state.allContacts,
      "secondList": _vm.isSageOne ? _vm.sageIDonly : _vm.addressbook,
      "placeholder": _vm.$t('AddressBook.title')
    },
    on: {
      "input": function($event) {
        _vm.setAndSearch($event, 'billing')
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerName,
      "disabled": _vm.billingSame,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.name') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.payerName = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerAddress,
      "disabled": _vm.billingSame,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.address') + '*'
    },
    on: {
      "input": function($event) {
        _vm.order.payerAddress = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerCity,
      "disabled": _vm.billingSame,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.city')
    },
    on: {
      "input": function($event) {
        _vm.order.payerCity = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerPostcode,
      "disabled": _vm.billingSame,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.postal_code')
    },
    on: {
      "input": function($event) {
        _vm.order.payerPostcode = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerProvince,
      "disabled": _vm.billingSame,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.province')
    },
    on: {
      "input": function($event) {
        _vm.order.payerProvince = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerCountry,
      "disabled": _vm.billingSame,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.country')
    },
    on: {
      "input": function($event) {
        _vm.order.payerCountry = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerEmail,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.email')
    },
    on: {
      "input": function($event) {
        _vm.order.payerEmail = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerPhone,
      "disabled": _vm.billingSame,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.phone')
    },
    on: {
      "input": function($event) {
        _vm.order.payerPhone = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerFax,
      "disabled": _vm.billingSame,
      "type": "tel",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.fax')
    },
    on: {
      "input": function($event) {
        _vm.order.payerFax = $event
      }
    }
  }), _vm._v(" "), _c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.order.payerContact,
      "disabled": _vm.billingSame,
      "type": "text",
      "placeholder": _vm.$t('OrderPending.pickupDeliveryTab.contact')
    },
    on: {
      "input": function($event) {
        _vm.order.payerContact = $event
      }
    }
  }), _vm._v(" "), _c('regular-checkbox', {
    staticClass: "col-12",
    attrs: {
      "checked": _vm.billingSame,
      "label": _vm.$t('OrderPending.pickupDeliveryTab.same_as_delivery')
    },
    on: {
      "change": function($event) {
        _vm.billingSame = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": !_vm.formCompleted
    },
    on: {
      "click": function($event) {
        _vm.addOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.submitOrder')))])])]) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.modal.openPrice) ? _c('modal', {
    attrs: {
      "closable": ""
    },
    on: {
      "close-request": function($event) {
        _vm.modal.openPrice = false
      }
    }
  }, [_c('h4', {
    staticClass: "mx-3 kne-title"
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.orderTab.confirmPrice')))]), _vm._v(" "), _c('div', [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.selected.price,
      "type": "number",
      "placeholder": _vm.$t('OrderPending.orderTab.price')
    },
    on: {
      "input": function($event) {
        _vm.selected.price = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {}, [_c('regular-input', {
    staticClass: "col-12 form-group",
    attrs: {
      "value": _vm.selected.datePromis,
      "type": "date",
      "placeholder": _vm.$t('OrderPending.orderTab.datePromis')
    },
    on: {
      "input": function($event) {
        _vm.selected.datePromis = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-kne-orange w-100",
    attrs: {
      "disabled": _vm.selected.price === ''
    },
    on: {
      "~click": function($event) {
        _vm.action(_vm.selected, true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('OrderPending.submitOrder')))])])]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ca68ab8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/OrderPending.vue
// module id = 846
// module chunks = 1